import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Pagination } from 'react-bootstrap'
import {
  addPeople,
  archiveMembers,
  updateToBeArchivedMembers,
  updatePageNum,
} from '../actions'
import { ArchiveConfirmModal } from './ArchiveConfirmModal'
import { AddPeopleModal } from './AddPeopleModal'
import ButterToast, { Cinnamon } from 'butter-toast'
import { METable } from '@CommonComponents'
import ActionButtonPeople from './ActionButtonPeople'
import ActionButtonUnarchive from './ActionButtonUnarchive'

class PeopleTables extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showAddPeopleModal: false,
      peopleInfo: '',
      roleSelection: 'student',
      sectionSelection: this.props.sectionRows[0].secName,
      paymentRecordSelection: 'no',
      notificationSelection: 'no',
      toBeArchived: [],
      archiveMembersModalOpen: false,
      enforceAccessFormValue: this.props.daysOfAccess > 0,
      displayArchivedTable: false,
    }

    this.toggleAddPeopleModal = this.toggleAddPeopleModal.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.handlePeopleInfoChange = this.handlePeopleInfoChange.bind(this)
    this.handleRoleSelectionChange = this.handleRoleSelectionChange.bind(this)
    this.handleSectionSelection = this.handleSectionSelection.bind(this)
    this.handlePaymentRecordSelection =
      this.handlePaymentRecordSelection.bind(this)
    this.handleNotificationSelection =
      this.handleNotificationSelection.bind(this)
    this.toggleArchiveMembersModal = this.toggleArchiveMembersModal.bind(this)
    this.handleEnforceAccessDays = this.handleEnforceAccessDays.bind(this)
  }

  toggleArchiveMembersModal() {
    this.setState({
      archiveMembersModalOpen: !this.state.archiveMembersModalOpen,
    })
  }

  itemIdxDisplayer(perPage, pageNum, pageItemCount, totalItemCount) {
    let baseIdx = perPage * (pageNum - 1)
    let startIdx = totalItemCount > 0 ? baseIdx + 1 : baseIdx
    return ` ${startIdx} - ${baseIdx + pageItemCount} of ${totalItemCount} `
  }

  columns = [
    'Select',
    'Role',
    'Section',
    'SchoolID',
    'Last Name',
    'First Name',
    'Signup Date',
    'Last Login',
    'Email',
    'Actions',
  ]
  archiveColumns = this.columns.slice(1, 10)

  handlePeopleInfoChange(e) {
    this.setState({
      peopleInfo: e.target.value,
    })
  }

  handleRoleSelectionChange(e) {
    this.setState({
      roleSelection: e.target.value,
    })
  }

  handleSectionSelection(e) {
    this.setState({
      sectionSelection: e.target.value,
    })
  }

  handlePaymentRecordSelection(e) {
    this.setState({
      paymentRecordSelection: e.target.value,
    })
  }

  handleNotificationSelection(e) {
    this.setState({
      notificationSelection: e.target.value,
    })
  }

  handleEnforceAccessDays(enforce) {
    this.setState({
      enforceAccessFormValue: enforce,
    })
  }

  toggleAddPeopleModal() {
    this.setState({
      showAddPeopleModal: !this.state.showAddPeopleModal,
      responseData: '',
    })
  }

  toggleArchivedTable() {
    this.setState({
      displayArchivedTable: !this.state.displayArchivedTable,
    })
  }

  showHideArchiveBtn = archiveList => {
    if (archiveList.length > 0) {
      return (
        <a
          className="btn btn-danger btn-myed btn-danger-myed mr-2"
          onClick={this.toggleArchiveMembersModal}
        >
          <i className="far fa-user-times fa-fw mr-2" /> Archive
        </a>
      )
    } else {
      return ''
    }
  }

  dispatchArchiveMembers = async () => {
    let data = this.props.filters
    data.toBeArchived = this.props.toBeArchived
    data.pageNum = this.props.currentCourseMemPage
    data.archivedPageNum = this.props.currentArchivePage
    let response = await this.props.archiveMembers(data)
    this.toggleArchiveMembersModal()
    if (response.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Success"
            content="Successfully archived the selected student(s)."
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
      this.setState({ toBeArchived: [] })
    } else {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content="There was a problem trying to archive student(s)."
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  sections = () => {
    return this.props.sectionRows.map((x, key) => (
      <option key={key} value={x.secName}>
        {x.secName}
      </option>
    ))
  }

  validatePeopleInfo = peopleInfo => {
    if (!peopleInfo) {
      throw new Error('Missing info for new user.')
    }
  }

  resetAddPeopleForm = () => {
    this.setState({
      showAddPeopleModal: false,
      peopleInfo: '',
      roleSelection: 'student',
      sectionSelection: this.props.sectionRows[0].secName,
      paymentRecordSelection: 'no',
      notificationSelection: 'no',
    })
  }

  async handleFormSubmit() {
    try {
      this.validatePeopleInfo(this.state.peopleInfo)
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            scheme={Cinnamon.Crunch.SCHEME_RED}
            content={err.message}
            title="Error"
          />
        ),
        sticky: true,
      })
      this.resetAddPeopleForm()
      return null
    }
    let data = this.props.filters
    data.people = this.state.peopleInfo
    data.role = this.state.roleSelection
    data.section = this.state.sectionSelection
    data.payment = this.state.paymentRecordSelection
    data.notify = this.state.notificationSelection
    data.enforceAccessDays = this.state.enforceAccessFormValue
    data.pageNum = this.props.currentCourseMemPage
    data.archivedPageNum = this.props.currentArchivePage

    let response = await this.props.addPeople(data)
    this.resetAddPeopleForm()
    ButterToast.raise({
      content: (
        <Cinnamon.Crunch
          scheme={Cinnamon.Crunch.SCHEME_GREY}
          content={response.data.results}
          title="Results"
        />
      ),
      sticky: true,
    })
  }

  addRemoveAll = () => {
    let studRows = this.props.peopleRowData.filter(
      row => row.role === 'student'
    )
    let archiveList = []
    if (studRows.length > this.props.toBeArchived.length) {
      for (let i = 0; i < studRows.length; i++) {
        archiveList.push(studRows[i].id)
      }
      return this.props.updateToBeArchivedMembers(archiveList)
    } else {
      return this.props.updateToBeArchivedMembers([])
    }
  }

  addRemoveSingle = rowId => {
    if (this.props.toBeArchived.indexOf(rowId) === -1) {
      this.props.updateToBeArchivedMembers([...this.props.toBeArchived, rowId])
    } else {
      this.props.updateToBeArchivedMembers(
        this.props.toBeArchived.filter(id => id !== rowId)
      )
    }
  }

  buildTableData = (peopleData, isArchivedTable) => {
    let cellRows = []
    peopleData.map((row, i) => {
      let newRow = [
        row.role === 'student' && !isArchivedTable && (
          <input
            type="checkbox"
            aria-label="select student"
            checked={this.props.toBeArchived.indexOf(row.id) > -1}
            onChange={() => this.addRemoveSingle(row.id)}
          />
        ),
        row.role,
        row.section,
        row.school_id,
        <a href={`/course/progress/${row.coursenum}/${row.userID}/`} key={i}>
          {row.lastName}
        </a>,
        <a href={`/course/progress/${row.coursenum}/${row.userID}/`} key={i}>
          {row.firstName}
        </a>,
        row.dateJoined,
        row.lastLogin,
        <a href={`mailto:${row.email}`} key={i}>
          {row.email}
        </a>,
        !isArchivedTable ? (
          <ActionButtonPeople
            user_id={row.id}
            account_id={row.userID}
            user_full_name={row.firstName + ' ' + row.lastName}
          />
        ) : (
          <ActionButtonUnarchive user_id={row.id} />
        ),
      ]
      if (isArchivedTable) {
        newRow = newRow.slice(1)
      }
      cellRows.push(newRow)
    })
    return cellRows
  }

  render() {
    return (
      <Fragment>
        <div className="p-3 card-myed">
          <div className="pull-right mb-2">
            {this.showHideArchiveBtn(this.props.toBeArchived)}
            <a
              className="btn btn-myed btn-default btn-default-myed"
              onClick={this.toggleAddPeopleModal}
            >
              Add / Edit People
            </a>
          </div>
          <h3>Course Members</h3>
          <p>
            Course members
            {this.itemIdxDisplayer(
              this.props.pageLimit,
              this.props.currentCourseMemPage,
              this.props.peopleRowData.length,
              this.props.peopleCount
            )}
            shown
          </p>
          {this.props.peopleRowData.filter(row => row.role === 'student')
            .length > 0 && (
            <label>
              <input
                type="checkbox"
                className="mr-3"
                checked={
                  this.props.peopleRowData.filter(row => row.role === 'student')
                    .length === this.props.toBeArchived.length &&
                  this.props.toBeArchived.length > 0
                }
                onChange={() => this.addRemoveAll()}
              />
              <span>Select students on page</span>
            </label>
          )}
          <METable
            columns={this.columns}
            data={this.buildTableData(this.props.peopleRowData, false)}
            columnCss={{ Actions: 'text-center' }}
          />
          <div className="text-center">
            <Pagination
              prev={<span className="text-dark">{'<'}</span>}
              next={<span className="text-dark">{'>'}</span>}
              first={<span className="text-dark">{'<<'}</span>}
              last={<span className="text-dark">{'>>'}</span>}
              maxButtons={5}
              items={Math.ceil(this.props.peopleCount / this.props.pageLimit)}
              activePage={this.props.currentCourseMemPage}
              onSelect={page =>
                this.props.updatePageNum({
                  page: page,
                  table: 'courseMember',
                  ...this.props.filters,
                })
              }
            />
          </div>
        </div>

        {this.props.archivedRowData.length > 0 && (
          <div className="pull-right mb-3 mr-3">
            <a
              className="btn btn-link btn-sm"
              onClick={() => this.toggleArchivedTable()}
            >
              {!this.state.displayArchivedTable
                ? 'View Archived Course Members'
                : 'Hide Archived Course Members'}
            </a>
          </div>
        )}
        <div
          className={
            this.state.displayArchivedTable &&
            this.props.archivedRowData.length > 0
              ? 'card-myed'
              : 'd-none'
          }
        >
          <h3>Archived Members</h3>
          <METable
            columns={this.archiveColumns}
            data={this.buildTableData(this.props.archivedRowData, true)}
            columnCss={{ Actions: 'text-center' }}
          />
          <div className="text-center">
            <Pagination
              prev={<span className="text-dark">{'<'}</span>}
              next={<span className="text-dark">{'>'}</span>}
              first={<span className="text-dark">{'<<'}</span>}
              last={<span className="text-dark">{'>>'}</span>}
              maxButtons={5}
              items={Math.ceil(this.props.archivedCount / this.props.pageLimit)}
              activePage={this.props.currentArchivePage}
              onSelect={page =>
                this.props.updatePageNum({
                  page: page,
                  table: 'archivedMember',
                  ...this.props.filters,
                })
              }
            />
          </div>
        </div>
        <AddPeopleModal
          showAddPeopleModal={this.state.showAddPeopleModal}
          toggleAddPeopleModal={this.toggleAddPeopleModal}
          handlePeopleInfoChange={this.handlePeopleInfoChange}
          handleRoleSelectionChange={this.handleRoleSelectionChange}
          handleSectionSelection={this.handleSectionSelection}
          handlePaymentRecordSelection={this.handlePaymentRecordSelection}
          handleNotificationSelection={this.handleNotificationSelection}
          handleFormSubmit={this.handleFormSubmit}
          sections={this.props.sectionRows}
          elevatedUser={this.props.elevatedUser}
          handleEnforceAccessDays={this.handleEnforceAccessDays}
          daysOfAccess={this.props.daysOfAccess}
        />
        <ArchiveConfirmModal
          archiveMembersModalOpen={this.state.archiveMembersModalOpen}
          toggleArchiveMembersModal={this.toggleArchiveMembersModal}
          dispatchArchiveMembers={this.dispatchArchiveMembers}
        />
      </Fragment>
    )
  }
}

PeopleTables.propTypes = {
  sectionRows: PropTypes.array,
  addPeople: PropTypes.func,
  archiveMembers: PropTypes.func,
  elevatedUser: PropTypes.bool,
  peopleCount: PropTypes.number,
  peopleRowData: PropTypes.array,
  archivedRowData: PropTypes.array,
  filters: PropTypes.object,
  daysOfAccess: PropTypes.number,
  toBeArchived: PropTypes.array,
  currentCourseMemPage: PropTypes.number,
  currentArchivePage: PropTypes.number,
  pageLimit: PropTypes.number,
  updatePageNum: PropTypes.func,
  updateToBeArchivedMembers: PropTypes.func,
  archivedCount: PropTypes.number,
}

const mapStateToProps = state => {
  return {
    sectionRows: state.sectionRowData,
    sectionModalOpen: state.sectionModalOpen,
    elevatedUser: state.elevatedUser,
    peopleCount: state.peopleCount,
    archivedCount: state.archivedCount,
    peopleRowData: state.peopleRowData,
    archivedRowData: state.archivedRowData,
    filters: state.filters,
    daysOfAccess: state.daysOfAccess,
    toBeArchived: state.toBeArchived,
    currentCourseMemPage: state.currentCourseMemPage,
    currentArchivePage: state.currentArchivePage,
    pageLimit: state.memPageLimit,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addPeople: data => dispatch(addPeople(data)),
    archiveMembers: memberList => dispatch(archiveMembers(memberList)),
    updateToBeArchivedMembers: memberList =>
      dispatch(updateToBeArchivedMembers(memberList)),
    updatePageNum: payload => dispatch(updatePageNum(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PeopleTables)
